import { render, staticRenderFns } from "./Addmodal.vue?vue&type=template&id=18e51abe&scoped=true&"
import script from "./Addmodal.vue?vue&type=script&lang=js&"
export * from "./Addmodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e51abe",
  null
  
)

export default component.exports